module.exports = __webpack_public_path__ + "img/益视说明书_03.377ceb18.png";